import Icon from 'veui/components/Icon'
import { IconComponent } from 'dls-icons-vue'

Icon.register('component', IconComponent)
